import { findIndex } from 'lodash';
import { Map } from 'immutable';
import { getStepsMapByYear, ndfl3StepsMapping } from './constants/Ndfl3StepsMapping';
import * as urlHelper from 'utils/urlHelper';
import { formValueSelector } from 'redux-form/immutable';
import { DEFAULT_REPORT_YEAR, NDFL_FORM_ID } from 'modules/Taps/components/NDFL3/constants/forms';

const selector = formValueSelector(NDFL_FORM_ID);

/**
 * build step validation class to make it easy determine the length of jumps
 * and applied steps it also works in both directions
 */
export class JumpStepValidation {
  fromStep = 0;
  toStep = 0;

  constructor(fromStep, toStep, validation) {
    this.fromStep = fromStep;
    this.toStep = toStep;
    this.validation = validation;
    this.validate = this.validate.bind(this);
  }

  validate(isGoForward) {
    if (this.validation()) {
      return isGoForward ? this.toStep : this.fromStep;
    }
    return -1;
  }
}

const getJumpStepMap = (ndfl3State, formState) => {
  const validations = [
    new JumpStepValidation(
      2,
      4,
      () =>
        !formState.getIn(['payload', 'deductionSelector'], Map()).delete('formId').includes(true),
    ),
  ];

  return validations.reduce((res, validation) => {
    res[validation.fromStep + 'f'] = () => validation.validate(true);
    res[validation.toStep + 'b'] = () => validation.validate();
    return res;
  }, {});
};
export const getNextOrBackStep = function (state, isGoingNext) {
  const ndfl3State = state.taps.ndfl3;
  const formState = selector(state, `Ndfl3Package`);
  const reportYear = formState.getIn(['payload', 'initialData', 'reportYear'], DEFAULT_REPORT_YEAR);
  const stepJumpMap = getJumpStepMap(ndfl3State, formState);
  const stepsMap = getStepsMapByYear(reportYear);
  let stepIndex = getStepIndexByRouter(stepsMap);
  const oldStepIndex = stepIndex;
  let nextStep = -1;
  const stepJump = stepJumpMap[stepIndex + (isGoingNext ? 'f' : 'b')];

  if (stepJump) {
    nextStep = stepJump();
  }

  if (nextStep > -1) {
    stepIndex = nextStep;
  } else {
    if (isGoingNext) {
      stepIndex = stepIndex + 1 < stepsMap.length ? stepIndex + 1 : oldStepIndex;
    } else {
      stepIndex = stepIndex > 0 ? stepIndex - 1 : oldStepIndex;
    }
  }
  return stepIndex;
};

export const getStepIndexByRouter = (stepsMap = ndfl3StepsMapping) => {
  let stepIndex = findIndex(stepsMap, (step) => step.name === urlHelper.getParameterByName('step'));
  return stepIndex > 0 ? stepIndex : 0;
};
